import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Table, Button, Form, Input, Select, Spin, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';
import Message from '../../component/message/message'; // 提示信息弹窗
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import context from '../../public/js/context';
import trans from './translation';
import './userAccountManagementAdminList.css';
import UploadModal from './uploadModal';
const { TabPane } = Tabs;
const UserAccountManagementAdminList = (props) => {
    const messageRef = useRef(); 
    const [form] = Form.useForm();
    const [tabIndex, setTabIndex] = useState("1");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [funcList, setFuncList] = useState([]);
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [groupMemberTables, setGroupMemberTables] = useState([]);
    const [isUpload, setIsUpload] = useState(false);
    useEffect(() => {
        search(pageSize, 1, "N");
    }, []);

    const search = (pageSizeNew, current, flag, isShowMsg) => {
        setTables([
            {
                adminID: "AD100001",
                adminName: "Chan Tai Man",
                email: "tmchan@thei.edu.hk",
                adminRole: "Super Admin",
                status: "Active",
            },
        ]);

    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (checkboxState.length === 1 && Config.funcInfo.canUpdate === "Y") {
                    edit();
                } else if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({ activeInd: 'Y' });
        setGroupMemberTables([]);
        setFlag("add");
        setTabIndex("2");
    }
    const download = () => {
        setIsUpload(true)
    }

    const update = (model, e) => {
        messageShowHandler();
        // searchById();

        initForm({
            adminID: "AD100001",
            adminName: "Chan Tai Man",
            email: "tmchan@thei.edu.hk",
            adminRole: "Super Admin",
            adminSurname: "Chan",
            adminGivenName: "Tai Man",
            status: "Active",
            phone:"13313313313"
        });
        setFlag("edit");
        setTabIndex("2");
    }


    const edit = () => {
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            adminID: model.adminID ?? "",
            adminName: model.adminName ?? "",
            email: model.email ?? "",
            adminRole: model.adminRole ?? "",
            status: model.status ?? "",
            adminSurname: model.adminSurname ?? "",
            adminGivenName: model.adminGivenName ?? "",
            phone: model.phone ?? "",
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        clearSelect();
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        // setIsLoad(true);
        // setSpinInfo(trans.deleteData[Config.backLang]);
        // let deleteModel = checkboxState[0];
        // deleteModel.menuFuncId = Config.funcInfo.funcId;
        // Base.callBackApi("role/delete", deleteModel).then((data) => {
        //     if ("SUCCESS" === data.msg) {
        //         cancel();
        //         search(pageSize, current, "Y", false);
        //         errFrameShow("success", trans.deleteSuccess[Config.backLang]);
        //         props.searchMenu(Config.userInfo.role);//刷新menu
        //     } else {
        //         errFrameShow("error", data.msg);
        //     }
        // }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onFinish = (values) => {
        messageShowHandler();
        // setIsLoad(true);
        // setSpinInfo(trans.dataBeSaving[Config.backLang])
        // let list = [];
        // for (let item of funcList) {
        //     if (item.children != null) {
        //         for (let iterator of item.children) {
        //             list.push(iterator);
        //             if (Base.isNotEmpty(iterator.children)) {
        //                 for (let subFunc of iterator.children) {
        //                     list.push(subFunc);
        //                 }
        //             }
        //         }
        //     }
        //     list.push(item);
        // }
        // values.funcList = list;
        // let url = "";
        // if (flag === "add") {
        //     url = "role/insert";
        // } else {
        //     url = "role/update"
        //     values.roleId = selectedRowKeys[0];
        //     values.lastUpdatedDate = checkboxState[0].lastUpdatedDate;
        // }
        // values.menuFuncId = Config.funcInfo.funcId;
        // values.roleCode = values.roleCode.toLocaleUpperCase();
        // Base.callBackApi(url, values).then((data) => {
        //     if ("SUCCESS" === data.msg) {
        //         searchById(data.object)
        //         errFrameShow("success", trans.saveSuccess[Config.backLang]);
        //     } else {
        //         errFrameShow("error", data.msg);
        //     }
        // }).catch(err => { }).finally(() => {
        //     setIsLoad(false);
        //     props.searchMenu(Config.userInfo.role);
        // });
    }

    const searchById = (model) => {
        setIsLoading(true);
        Base.callBackApi("role/searchById", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let roleModel = data.object;
                initForm(roleModel);
                setCheckboxState([roleModel]);
                setSelectedRowKeys([roleModel.roleId]);
                setFlag("edit");
                setFuncList(roleModel.funcList);
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoading(false));
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        setGroupMemberTables([]);
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();

        setIsDeleteFrame(true);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    // 生成提示信息
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    // 清除提示信息
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const uploadClose = (flag) => {
        // if (flag) {
        //     if (!(Config.userInfo.role.roleCode === "SYS_ADMIN" || Config.userInfo.role.roleCode === "ADMIN") || searchModel.customerMgtId) {
        //         search(pageSize, 1, "N");
        //     }
        //     errFrameShow("success", trans.importSuccess[Config.backLang]);
        // }
        setIsUpload(false);
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Admin ID',
            dataIndex: 'adminID',
            className: 'tableWidth15',
        },
        {
            title: 'Admin Name',
            dataIndex: 'adminName',
            className: 'tableWidth20',
        },
        {
            title: "Email",
            dataIndex: 'email',
            className: 'tableWidth15',
        },
        {
            title: "Admin Role",
            dataIndex: 'adminRole',
            className: 'tableWidth8',
        },
        {
            title: "Status",
            dataIndex: 'status',
            className: 'tableWidth8',
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: 'tableWidth14 sysControls',
            fixed:'right',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];


    return (
        <div id="container" className="template userAccountManagementAdminList">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysSearchRow sysSearchBox'>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.adminID[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.adminID || ''}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('adminID', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle">{trans.adminName[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" value={searchModel.adminName || ''}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                                onChange={(e) => searchChange('adminName', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                                {/* <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<EditOutlined />}>{trans.update[Config.backLang]}</Button> */}
                                <Button type="primary" className="sysBtn btnBlue" onClick={download} hidden={Config.funcInfo.canInsert === "N"} icon={<UploadOutlined />}>{trans.batchUpload[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 1400 }}
                                    rowKey="roleId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,          //默认当前页为1
                                        size: "small"
                                    }}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.adminList[Config.backLang]} forceRender={true}>
                            <Form form={form}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">{trans.adminID[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="adminID"
                                                getValueFromEvent={(e) => Base.codeChange(e, 20)}
                                            >
                                                <Input type="text" placeholder={trans.adminID[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">{trans.adminSurname[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="adminSurname"
                                            >
                                                <Input type="text" placeholder={trans.adminSurname[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">{trans.adminGivenName[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="adminGivenName"
                                            >
                                                <Input type="text" placeholder={trans.adminGivenName[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">{trans.email[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="email"
                                            >
                                                <Input type="text" placeholder={trans.email[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">{trans.phone[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="phone"
                                            >
                                                <Input type="text" placeholder={trans.phone[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">{trans.adminRole[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="adminRole"
                                            >
                                                <Input type="text" placeholder={trans.adminRole[Config.backLang]} maxLength={20} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam sysParamInput">{trans.status[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="status"
                                            >
                                                <Select className='sysSelect'>
                                                    <Option value=''></Option>
                                                    {context.userAccountManagementStudent.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isUpload && <UploadModal onClose={uploadClose} />}
        </div>
    )

}

export default UserAccountManagementAdminList;